// this file contains all the global action names constants to be used in both
// action creators and reducers

export const LOADING_DATA = 'loading'
export const USER_LOGOUT = 'USER_LOGOUT'
export const NAV_INDEX = 'NAV_INDEX'

export const USER_LOGIN_LOADING = 'USER_LOGIN_LOADING'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR'
export const USER_LOGIN_CLEAR = 'USER_LOGIN_CLEAR'
export const USER_UPDATE_SUCCESS = 'user-update-success'
export const REMOVE_OPENTOK_TOKEN = 'REMOVE_OPENTOK_TOKEN'

export const USER_SIGNUP_BLANK = 'USER_SIGNUP_BLANK'
export const USER_SIGNUP_LOADING = 'USER_SIGNUP_LOADING'
export const USER_SIGNUP_SUCCESS = 'USER_SIGNUP_SUCCESS'
export const USER_SIGNUP_ERROR = 'USER_SIGNUP_ERROR'

export const UPDATE_PROFILE_LOADING = 'UPDATE_PROFILE_LOADING'
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS'
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR'

export const DELETE_PROFILE_LOADING = 'DELETE_PROFILE_LOADING'
export const DELETE_PROFILE_ERROR = 'DELETE_PROFILE_ERROR'
export const DELETE_PROFILE_SUCCESS = 'DELETE_PROFILE_SUCCESS'

export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS'
export const GET_PROFILE_ERROR = 'GET_PROFILE_ERROR'
export const GET_PROFILE_LOADING = 'GET_PROFILE_LOADING'

export const CLEAR_CART = 'CLEAR_CART'
export const GET_CART_LOADING = 'GET_CART_LOADING'
export const GET_CART_SUCCESS = 'GET_CART_SUCCESS'
export const GET_CART_ERROR = 'GET_CART_ERROR'
export const ADD_NEW_CART_ITEM_SUCCESS = 'ADD_NEW_CART_ITEM_SUCCESS'
export const ADD_NEW_CART_ITEM_ERROR = 'ADD_NEW_CART_ITEM_ERROR'
export const DELETE_CART_ITEM_SUCCESS = 'DELETE_CART_ITEM_SUCCESS'
export const DELETE_CART_ITEM_ERROR = 'DELETE_CART_ITEM_ERROR'
export const ADD_NEW_FAVORITE_ITEM = 'ADD_NEW_FAVORITE_ITEM'
export const DELETE_FAVORITE_ITEM = 'DELETE_FAVORITE_ITEM'
export const UPDATE_LOCAL_CART = 'UPDATE_LOCAL_CART'
export const REMOVE_LOCAL_CART = 'REMOVE_LOCAL_CART'

export const ITEM_OPTIONS_LOADING = 'ITEM_OPTIONS_LOADING'
export const ITEM_OPTIONS_SUCCESS = 'ITEM_OPTIONS_SUCCESS'
export const ITEM_OPTIONS_ERROR = 'ITEM_OPTIONS_ERROR'

export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_LODING = 'CHECKOUT_LODING'
export const CHECKOUT_ERROR = 'CHECKOUT_ERROR'

// buyer order
export const GET_BUYER_ORDER_LIST_LOADING = 'GET_BUYER_ORDER_LIST_LOADING'
export const GET_BUYER_ORDER_LIST_SUCCESS = 'GET_BUYER_ORDER_LIST_SUCCESS'
export const GET_BUYER_ORDER_LIST_ERROR = 'GET_BUYER_ORDER_LIST_ERROR'

export const GET_SELLING_LIST_LOADING = 'GET_SELLING_LIST_LOADING'
export const GET_SELLING_LIST_SUCCESS = 'GET_SELLING_LIST_SUCCESS'
export const GET_SELLING_LIST_ERROR = 'GET_SELLING_LIST_ERROR'
export const GET_PURCHASED_LIST_SUCCESS = 'GET_PURCHASED_LIST_SUCCESS'
export const GET_PURCHASED_LIST_ERROR = 'GET_PURCHASED_LIST_ERROR'
export const GET_SELLING_ITEM_DETAIL_LOADING = 'GET_SELLING_ITEM_DETAIL_LOADING'
export const GET_SELLING_ITEM_DETAIL_SUCCESS = 'GET_SELLING_ITEM_DETAIL_SUCCESS'
export const GET_SELLING_ITEM_DETAIL_ERROR = 'GET_SELLING_ITEM_DETAIL_ERROR'

export const UPDATE_SELLING_ITEM_LOADING = 'UPDATE_SELLING_ITEM_LOADING'
export const UPDATE_SELLING_ITEM_SUCCESS = 'UPDATE_SELLING_ITEM_SUCCESS'
export const UPDATE_SELLING_ITEM_ERROR = 'UPDATE_SELLING_ITEM_ERROR'

export const GET_FILTRE_DATA = 'GET_FILTRE_DATA'
export const GET_FILTRE_DATA_LOADING = 'GET_FILTRE_DATA_LOADING'
export const GET_FILTRE_DATA_ERROR = 'GET_FILTRE_DATA_ERROR'

export const ADD_NEW_BUNNDLE = 'ADD_NEW_BUNNDLE'
export const DELETE_BUNDLE_ITEM = 'DELETE_BUNDLE_ITEM'
export const UPDATE_BUNDLE_ITEM = 'UPDATE_BUNDLE_ITEM'
export const PUBLISH_BUNDLE = 'PUBLISH_BUNDLE'
export const PUBLISH_BUNDLE_ERROR = 'PUBLISH_BUNDLE_ERROR'
export const ADD_NEW_ITEM = 'ADD_NEW_ITEM'
export const ADD_NEW_ITEM_ERROR = 'ADD_NEW_ITEM_ERROR'

export const UPDATE_LISTING_ITEM = 'UPDATE_LISTING_ITEM'
export const DELETE_LISTING_ITEM = 'DELETE_LISTING_ITEM'

export const GET_SHOP_LIST_LOADING = 'GET_SHOP_LIST_LOADING'
export const GET_SHOP_LIST_SUCCESS = 'GET_SHOP_LIST_SUCCESS'
export const GET_SHOP_LIST_ERROR = 'GET_SHOP_LIST_ERROR'

export const STRIPE_CONNECTION_SUCCESS = 'STRIPE_CONNECTION_SUCCESS'
export const STRIPE_CONNECTED = 'STRIPE_CONNECTED'

//Old
export const GET_ROOM_LIST_LOADING = 'GET_ROOM_LIST_LOADING'
export const GET_ROOM_LIST_SUCCESS = 'get-room-list-success'
export const GET_ROOM_LIST_ERROR = 'get-room-list-error'

export const LOCAL_CART_DATA = 'LOCAL_CART_DATA'
export const LOCAL_CART_DATA_LOADING = 'LOCAL_CART_DATA_LOADING'

export const PHONE_VERIFICATION_BLANK = 'PHONE_VERIFICATION_BLANK'
export const PUBLISHER_TOKEN_LOADING = 'PUBLISHER_TOKEN_LOADING'
export const PUBLISHER_TOKEN_SUCCESS = 'PUBLISHER_TOKEN_SUCCESS'
export const PUBLISHER_TOKEN_ERROR = 'PUBLISHER_TOKEN_ERROR'

export const SEND_VERIFICATION_CODE_SUCCESS = 'send-verification-code-success'
export const SEND_VERIFICATION_CODE_ERROR = 'send-verification-code-error'
export const VERIFY_VERIFICATION_CODE_SUCCESS = 'verify-verification-code-success'
export const VERIFY_VERIFICATION_CODE_ERROR = 'verify-verification-code-error'

//forgot Password
export const FORGOT_PASSWORD_LOADING = 'forgot-password-loading'
export const FORGOT_PASSWORD_SUCCESS = 'forgot-password-success'
export const FORGOT_PASSWORD_FAILURE = 'forgot-password-failure'

//Reset Password
export const RESET_PASSWORD_LOADING = 'reset-password-loading'
export const RESET_PASSWORD_SUCCESS = 'reset-password-success'
export const RESET_PASSWORD_FAILURE = 'reset-password-failure'

//Resend Email
export const RESEND_EMAIL_LOADING = 'RESEND-EMAIL-LOADING'
export const RESEND_EMAIL_SUCCESS = 'RESEND-EMAIL-SUCCESS'
export const RESEND_EMAIL_FAILURE = 'RESEND-EMAIL-FAILURE'

// Toast
export const SHOW_TOAST = 'SHOW_TOAST'
export const CLEAR_TOAST = 'CLEAR_TOAST'
